import { Flex } from "@chakra-ui/react";
import ContentItem from "ui/components/ContentItem";
import { Row, Col } from "antd";
import { ClienteContrato } from "core/features/cliente/typings";
import moment from "moment";

interface DescricaoContratoClienteProps {
  item?: ClienteContrato;
}

export default function DescricaoContratoCliente({
  item,
}: DescricaoContratoClienteProps) {
  return (
    <>
      <Flex py="4px" as={Row} gutter={8}>
        <Flex as={Col} xs={12} flexDirection="column">
          <ContentItem
            titulo="Matrícula Imóvel:"
            descricao={item?.matricula ? item?.matricula : "--"}
          />
        </Flex>
        <Flex as={Col} xs={12} flexDirection="column">
          <ContentItem
            titulo="Corretor:"
            descricao={item?.nomeCorretor ? item?.nomeCorretor : "--"}
          />
        </Flex>
      </Flex>
      <Flex py="4px" as={Row} gutter={8}>
        <Flex as={Col} xs={12} flexDirection="column">
          <ContentItem
            titulo="Assinatura do Contrato:"
            descricao={
              item?.assinatura
                ? moment(item?.assinatura).format("DD/MM/YYYY")
                : "--"
            }
          />
        </Flex>
        {item?.ativo ? (
          <Flex as={Col} xs={12} flexDirection="column">
            <ContentItem
              titulo="Duração do Contrato:"
              descricao={item?.duracao ? item?.duracao : "--"}
            />
          </Flex>
        ) : (
          <Flex as={Col} xs={12} flexDirection="column">
            <ContentItem
              titulo="Fim do Contrato:"
              descricao={
                item?.tempoFimContrato
                  ? moment(item?.tempoFimContrato).format("DD/MM/YYYY")
                  : "--"
              }
            />
          </Flex>
        )}
      </Flex>
    </>
  );
}
